import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { reactive } from 'vue';
import { PageWithChildrenDto } from 'stores/modules/page';
import SvProjectTabs from './SvProjectTabs.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvProductENTabs',
  props: {
    pages: {}
  },
  setup(__props: any) {



const state = reactive({
  tab: 0,
});

return (_ctx: any,_cache: any) => {
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_tab_panels, {
      class: "bg-transparent",
      style: {"height":"32rem"},
      modelValue: state.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.tab) = $event)),
      animated: "",
      swipeable: "",
      vertical: "",
      "transition-prev": "jump-up",
      "transition-next": "jump-up"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page, i) => {
          return (_openBlock(), _createBlock(_component_q_tab_panel, {
            key: page.id,
            class: "p-1",
            name: i
          }, {
            default: _withCtx(() => [
              _createVNode(SvProjectTabs, { pages: _ctx.pages }, null, 8, ["pages"])
            ]),
            _: 2
          }, 1032, ["name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})